import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from './useAuth';

const RequireRole = ({ roles = [], children }) => {
  const { user, hasRole } = useAuth();
 

  if (hasRole(roles)) return children;

  return <Navigate to="/" replace />;
};

export default RequireRole;
